export default "__VITE_ASSET__O$WJB9ev__"